import angular from 'angular';
import ComponentsModule from '../components-module';

import template from './code-user-session.html';

const COMPONENT_NAME = 'codeUserSession';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    controller: function ($rootScope,
      $location,
      Application,
      AuthenticationService,
      UserDataService,
      UserProfileModal,
      ErrorMessagingService,
      ApplicationConfigurationService) {

      let ctrl = this;

      function getCurrentUser () {
        AuthenticationService.getCurrentUser ()
          .then ((currentUser) => {
            ctrl.loginName = currentUser.userId;
            return UserDataService.getUserData (ctrl.loginName);
          })
          .then ((userData) => {
            ctrl.passport = atex.aceui.ObjectUtils.getByPath (userData, 'userData/acePassport');
          })
          .catch ((error) => {
            ErrorMessagingService.sendError (atex.aceui.error.Error ({
              type: atex.aceui.error.types.RUNTIME,
              severity: atex.aceui.error.severities.MAJOR,
              origin: COMPONENT_NAME,
              cause: 'Error while fetching user data the for current user.',
              rootCause: error
            }));
          });
      }

      ctrl.logout = () => {
        AuthenticationService.logout ();
      };

      ctrl.openUserProfile = () => {
        UserProfileModal.open ($rootScope, ctrl.passport, 'static');
      };

      ctrl.$onInit = () => {
        getCurrentUser();

        ApplicationConfigurationService.getConfigurationsFor(['Environment'])
          .then(([environmentConfiguration]) => {
            if (environmentConfiguration) {
              ctrl.environment = {
                'color': environmentConfiguration.color,
                'name': environmentConfiguration.name
              };
            }
          });

        $rootScope.$on('aceui:authenticationSuccess', getCurrentUser);
      };
    }
  });

export default COMPONENT_NAME;
